import React, { useMemo, useState } from 'react'
import { Modal, Button, Input } from 'antd'
import {WarningOutlined} from "@ant-design/icons";

const DisconnectSubdomain = ({
                                 error,
                                 open,
                                 title,
                                 loading,
                                 disconnectSubdomain,
                                 handleCloseDialog,
                                  activeHelpcenter
                               }) => {
  const [url, setUrl] = useState('')

  const renderContent = useMemo(() => {
    return (
      <div className="d-flex flex-column">
        <span>Enter your Help Center URL</span>
        <div className="mt-2">
          <Input
            value={url}
            onChange={(event) => {
              setUrl(event.target.value)
            }}
          />
        </div>
        {error && (
          <div className="mt-2 text-danger">
            <span>
              Unable to disconnect this Help Center. Please{' '}
              <a
                style={{ cursor: 'pointer' }}
                className={'text-primary'}
                href="mailto:support@swifteq.com"
              >
                contact us
              </a>
              .
            </span>
          </div>
        )}
      </div>
    )
  }, [error, url])

  return <Modal
    open={open}
    closable={!loading}
    title={<div className="d-flex">
      {title}
    </div>}
    onOk={() => disconnectSubdomain && disconnectSubdomain()}
    onCancel={() => handleCloseDialog && !loading && handleCloseDialog()}
    footer={[
      <Button
        type="primary"
        loading={loading}
        key="add"
        onClick={() => disconnectSubdomain && disconnectSubdomain()}
      >
        Yes, I am sure
      </Button>,
      <Button disabled={loading} key="back" onClick={() => handleCloseDialog && handleCloseDialog()}>
        Cancel
      </Button>,
    ]}
  >
    <div className="d-flex flex-column align-items-center justify-content-center">
      <div className='d-flex align-items-center'>
        <WarningOutlined className="mr-3" style={{ fontSize: 34, color: 'red' }} />
        <h5>Are you sure you want to disconnect <b>{activeHelpcenter}</b>?</h5>
      </div>
      <div className={"mt-3"}>
        Doing this will remove this help center's data from Swifteq, but will keep the data in your Zendesk account.
      </div>
    </div>
  </Modal>
}

export default DisconnectSubdomain
